import { FlightSegment } from '@pelicargo/types';

export const sortByAirport = (
  flightSegments: Pick<FlightSegment, 'origin_airport_id' | 'destination_airport_id'>[],
) => {
  const nextFlightSegments = [...flightSegments];

  // Sort flight segments by their departure airport, then by arrival airport
  return nextFlightSegments.sort((a, b) => {
    if (!a?.origin_airport_id || !b?.origin_airport_id) {
      return 0; // If either segment has no origin airport, consider them equal
    }
    if (a.origin_airport_id === b.origin_airport_id && !a?.destination_airport_id && !b?.destination_airport_id) {
      return 0; // If both segments have the same origin and no destination, consider them equal
    }
    if (!a?.destination_airport_id || !b?.destination_airport_id) {
      return a?.origin_airport_id.localeCompare(b?.origin_airport_id); // If one segment has no destination, sort by origin airport
    }
    if (a.origin_airport_id === b.origin_airport_id && a?.destination_airport_id && b?.destination_airport_id) {
      return a?.destination_airport_id.localeCompare(b?.destination_airport_id); // If both segments have the same origin, sort by destination airport
    }

    // If origin airports are different, sort by origin airport
    if (a.origin_airport_id === b.origin_airport_id) {
      return a?.destination_airport_id?.localeCompare(b?.destination_airport_id);
    }
    return a?.origin_airport_id.localeCompare(b?.origin_airport_id);
  });
};
